import { Component } from '@angular/core';
import { DialogBaseViewComponent, FormBase, Required } from '@sb/library/base';
import { FormFieldRecurrencePickerComponent, FormFieldRecurrencePickerScope } from '../form-field-recurrence-picker.component';

class Form extends FormBase {
    ApplyToFutureEntries = Required(EditRecurringOption);
}

export enum EditRecurringOption {
    ThisOnly = 'ThisOnly',
    ThisAndFuture = 'ThisAndFuture'
}

@Component({
    templateUrl: './edit-recurrence-dialog.component.html'
})
export class EditRecurrenceDialogComponent extends DialogBaseViewComponent<EditRecurringOption | null> {

    Scope = this.SetScope({
        Requires: FormFieldRecurrencePickerScope
    });

    readonly form = Form.Create();

    override ngOnInit() {
        super.ngOnInit();
        this.form.controls.ApplyToFutureEntries.setValue(this.data ?? EditRecurringOption.ThisOnly);
    }

    override PrimaryAction(): void {
        this.Scope.SetApplyToFutureMode(this.form.controls.ApplyToFutureEntries.value);

        super.PrimaryAction();
        this.DismissAction();
    }

    get EditRecurringOption(): typeof EditRecurringOption {
        return EditRecurringOption;
    }
}
